import { InlineIcon } from "@iconify/react-with-api";
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IApplicationState } from "../../state/ducks";
import { AppAccessState, PAGE_ACCOUNT_MANAGEMENT } from "../../state/ducks/access";
import { configContext } from "../config-provider";
import { MenuItem } from "./item";
import { Menu } from "./menu";
import { SubMenu } from "./submenu";

const menu = [
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>INVENTORY</span>
      </div>
    ),
    key: "inventory",
    children: [
      {
        key: "inventory-lamppost",
        title: "LAMPPOST",
        route: "/dashboard/inventory/lamppost",
      },
      {
        key: "inventory-lantern",
        title: "LANTERN",
        route: "/dashboard/inventory/lantern",
      },
      {
        key: "inventory-bollard",
        title: "BOLLARD",
        route: "/dashboard/inventory/bollard",
      },
      {
        key: "inventory-controller",
        title: "CONTROLLER",
        route: "/dashboard/inventory/controller",
      },
      {
        key: "inventory-cable",
        title: "CABLE",
        route: "/dashboard/inventory/cable",
      },
      {
        key: "inventory-gsds",
        title: "GSDS",
        route: "/dashboard/inventory/gsds",
      },
      {
        key: "inventory-connector",
        title: "CONNECTOR",
        route: "/dashboard/inventory/connector",
      },
      {
        key: "inventory-drawpit",
        title: "DRAWPIT",
        route: "/dashboard/inventory/drawpit",
      },
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>INSPECT</span>
      </div>
    ),
    key: "inspect",
    children: [
      {
        key: "inspect-overview",
        title: "OVERVIEW",
        route: "/dashboard/inspect/overview",
      },
      {
        key: "inspect-inspection",
        title: "INSPECT",
        route: "/dashboard/inspect/inspection",
      },
      {
        key: "inspect-column",
        title: "COLUMN",
        route: "/dashboard/inspect/column",
      },
      {
        key: "inspect-lantern",
        title: "LANTERN",
        route: "/dashboard/inspect/lantern",
      },
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>MAINTENANCE</span>
      </div>
    ),
    key: "maintenance",
    children: [
      {
        key: "maintenance-overview",
        title: "OVERVIEW",
        route: "/dashboard/maintenance/overview",
      },
      {
        key: "maintenance-lamppost",
        title: "LAMPPOST",
        route: "/dashboard/maintenance/lamppost",
      },
      {
        key: "maintenance-bollard",
        title: "BOLLARD",
        route: "/dashboard/maintenance/bollard",
      },
      {
        key: "maintenance-controller",
        title: "CONTROLLER",
        route: "/dashboard/maintenance/controller",
      },
      {
        key: "maintenance-cable",
        title: "CABLE",
        route: "/dashboard/maintenance/cable",
      },
      {
        key: "maintenance-gsds",
        title: "GSDS",
        route: "/dashboard/maintenance/gsds",
      },
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>FAULT</span>
      </div>
    ),
    key: "fault",
    children: [
      {
        key: "fault-overview",
        title: "OVERVIEW",
        route: "/dashboard/fault/overview",
      },
      {
        key: "fault-lamppost",
        title: "LAMPPOST",
        route: "/dashboard/fault/lamppost",
      },
      {
        key: "fault-bollard",
        title: "BOLLARD",
        route: "/dashboard/fault/bollard",
      },
      {
        key: "fault-controller",
        title: "CONTROLLER",
        route: "/dashboard/fault/controller",
      },
      {
        key: "fault-cable",
        title: "CABLE",
        route: "/dashboard/fault/cable",
      },
      {
        key: "fault-gsds",
        title: "GSDS",
        route: "/dashboard/fault/gsds",
      },
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>PROGRAMME</span>
      </div>
    ),
    key: "programme",
    children: [
      {
        key: "programme-overview",
        title: "OVERVIEW",
        route: "/dashboard/programme/overview",
      },
      {
        key: "programme-programme",
        title: "PROGRAMME",
        route: "/dashboard/programme/programme",
      },
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>COMPLAINT</span>
      </div>
    ),
    key: "complaint",
    children: [
      {
        key: "complaint-overview",
        title: "OVERVIEW",
        route: "/dashboard/complaint/overview",
      },
      {
        key: "complaint-complaint",
        title: "COMPLAINT",
        route: "/dashboard/complaint/complaint",
      },
      {
        key: "complaint-relationship",
        title: "COMP_INV_REL...",
        route: "/dashboard/complaint/relationship",
      },
      {
        key: "complaint-case",
        title: "CASE_DETAILS",
        route: "/dashboard/complaint/case",
      },
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:cube-outline" fontSize={36} />
        <span>MONTHLY REPORT DOWNLOAD</span>
      </div>
    ),
    key: "pdf",
    children: [
      {
        key: "pdf-list",
        title: "MONTHLY_REPORT...",
        route: "/dashboard/pdf/list",
      }
    ],
  },
  {
    title: (
      <div className="portal-inline-item">
        <InlineIcon icon="mdi:shield-account-outline" fontSize={36} />
        <span>ACCOUNT MANAGEMENT</span>
      </div>
    ),
    key: "account",
    // Hidden unless the user's appAccess lists this page. Hiding the entry is
    // presentation only — the route guard and the auth server's own /locks
    // privilege are what actually enforce it.
    requiresPage: PAGE_ACCOUNT_MANAGEMENT,
    children: [
      {
        key: "account-locked",
        title: "LOCKED_ACCOUNTS",
        route: "/dashboard/account/locked",
      },
    ],
  },
];

export const SideMenu: React.FC = () => {
  const history = useHistory();
  const { disableBollard } = useContext(configContext);
  const access = useSelector<IApplicationState, AppAccessState>((state) => state.access);

  const itemOnClick = (child: any) => {
    if (child.route) {
      history.push(child.route);
    }
  };

  const split = window.location.href.split("/");

  return (
    <Menu
      className="portal-menu"
      defaultSelectedKey={`${split[split.length - 2]}-${
        split[split.length - 1]
      }`}
      defaultOpenKeys={[split[split.length - 2]]}
    >
      {menu
        .filter(
          (row) =>
            !(row as { requiresPage?: string }).requiresPage ||
            access.pages.includes((row as { requiresPage?: string }).requiresPage as string)
        )
        .map((row) =>
        row.children ? (
          <SubMenu datakey={row.key} title={row.title} key={row.key}>
            {row.children.filter((child) => !(disableBollard && child.key.includes("bollard"))).map((child) => (
              <MenuItem
                datakey={child.key}
                key={child.key}
                onClick={() => {
                  itemOnClick(child);
                }}
              >
                {child.title}
              </MenuItem>
            ))}
          </SubMenu>
        ) : (
          <MenuItem
            datakey={row.key}
            key={row.key}
            className="first-layer"
            onClick={() => {
              itemOnClick(row);
            }}
          >
            {row.title}
          </MenuItem>
        )
      )}
    </Menu>
  );
};
